export const isContentEqual = (a?: any[], b?: any[]): boolean => {
  const listA = a || [];
  const listB = b || [];

  return (
    listA.length === listB.length &&
    [...listA].sort().every((val, i) => val === [...listB].sort()[i])
  );
};
